/** Bound both connection and body reads, retaining caller cancellation. */
export async function request<T>(url: string, init?: RequestInit, timeoutMs = (init?.method ?? "GET") === "GET" ? 15_000 : 0): Promise<T> {
  const deadline = new AbortController();
  const timer = timeoutMs > 0 ? setTimeout(() => deadline.abort(new Error("Loading timed out. Please retry.")), timeoutMs) : undefined;
  const signal = init?.signal ? AbortSignal.any([init.signal, deadline.signal]) : deadline.signal;
  try {
    const response = await fetch(url, { ...init, signal });
    if (!response.ok) throw new Error(`Orik request failed (${response.status})`);
    return response.status === 204 ? undefined as T : await response.json() as T;
  } finally { clearTimeout(timer); }
}
